import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default ({ width = 48, height = 48 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(width)}
    height={scaleSize(height)}
    viewBox="0 0 48 48"
  >
    <path
      className="stroke-change"
      fill="none"
      fillRule="evenodd"
      stroke="#9F9F9F"
      strokeWidth="3"
      d="M23.977 37.05c6.464-5.397 10.695-9.577 12.658-12.47 2.755-4.063 2.398-8.89-.68-12.116-2.702-2.833-7.736-2.535-10.946.505l-1.031.978-1.032-.977c-3.214-3.044-8.132-3.34-10.835-.506-3.11 3.26-3.524 8.087-.793 12.115 1.962 2.893 6.193 7.073 12.659 12.471z"
    />
  </svg>
);
